// extracted by mini-css-extract-plugin
export default {"cls1":"fSXTDKHB1cM1eoLsW8MV","cls2":"AnsqvHbdK0FwYYo_IDiW fSXTDKHB1cM1eoLsW8MV","isPhone":"_qvjKgwgzzpnVFGJEKDk"};